import type { ActionDocument } from '@quipex/shared/contracts';
import type { PackRow } from './models';

export function groupPackDocuments(
    documents: readonly ActionDocument[],
    rowNames: ReadonlyMap<string, string>,
    sectionNames: ReadonlyMap<string, string>,
    defaultSection: string,
    requirementIds: ReadonlyMap<string, string> = new Map()
): { name: string; requirements: PackRow[] }[] {
    const sections = new Map<string, Map<string, PackRow>>();
    for (const document of documents) {
        const name = (
            sectionNames.get(document.documentId) ?? defaultSection
        ).trim();
        if (!name) throw new Error('Enter a section name for each document.');
        const rows = sections.get(name) ?? new Map<string, PackRow>();
        const id =
            requirementIds.get(document.documentId) ?? document.documentId;
        const row = rows.get(id) ?? {
            name: rowNames.get(document.documentId) ?? '',
            documentIds: [],
        };
        if (row.documentIds.length >= 5)
            throw new Error(
                'Each requirement can have at most five documents. Choose another requirement for the extra document.'
            );
        row.documentIds.push(document.documentId);
        rows.set(id, row);
        sections.set(name, rows);
    }
    return [...sections].map(([name, rows]) => ({
        name,
        requirements: [...rows.values()],
    }));
}
